/* global jQuery:false _:false moment:false Swiper:false */


/* eslint-disable */
webpackJsonp([8],{

/***/ 										19:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";


	var _waypoint = __webpack_require__(1);

	var _waypoint2 = _interopRequireDefault(_waypoint);

	var _timelinelite = __webpack_require__(0);

	var _timelinelite2 = _interopRequireDefault(_timelinelite);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	new Swiper(".swiper-container", {
		slidesPerView: "auto",
		navigation: {
			nextEl: ".q-carousel-button--next",
			prevEl: ".q-carousel-button--prev",
			disabledClass: "q-carousel-button--disabled"
		},
		spaceBetween: 30
	});

	// hero animations
	var t = new _timelinelite2.default();

	var hero = document.querySelector(".q-alternate-hero");
	var heroContent = document.querySelector(".q-alternate-hero__content");
	var text = heroContent.childNodes;
	var heroImage = document.querySelector(".q-alternate-hero__image-wrap");

	var waypoint1 = new _waypoint2.default({
		element: hero,

		offset: "100%",

		handler: function handler(direction) {
			if (direction === "down") {
				t.addLabel("start").staggerFromTo(text, 1, { y: "20%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: window.Power4.easeInOut }, 0.1).fromTo(heroImage, 1, { y: "-30%", autoAlpha: 0 }, { y: "0%", autoAlpha: 1, ease: window.Power4.easeInOut }, "start+=.8");
			}
		}
	});

	// filter button expand collapse example
	var button = document.querySelectorAll(".q-resources-filter__category-header");
	var activeButtonClass = "q-resources-filter__category-button--active";
	var closedCategoryClass = "q-resources-filter__category--closed";

	Array.prototype.forEach.call(button, function (el) {
		el.addEventListener("click", function () {
			var target = el.dataset.category || null;
			var targetClass = document.getElementById(target).classList;

			if (targetClass.contains(closedCategoryClass)) {
				targetClass.remove(closedCategoryClass);
				el.classList.add(activeButtonClass);
			} else {
				targetClass.add(closedCategoryClass);
				el.classList.remove(activeButtonClass);
			}
		});
	});

/***/ }),

/***/ 										39:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 										73:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(19);
	module.exports = __webpack_require__(39);


/***/ })

},[73]);
/* eslint-enable */


/*
 * filter resources and show resources based on hash value
 */
(function ($, _) {

	"use strict";

	var filterType = "",
		args,
		doOnce = false;

	function handleHashchange () {
		var hash = getHash();

		switch(hash) {
		case "analyst-report":
			window.location = "/resources/#/type/analyst-report/topic/all/language/all";
			break;
		case "datasheet":
			window.location = "/resources/#/type/datasheet/topic/all/language/all";
			break;
		case "dummies-ebook":
			window.location = "/resources/#/type/dummies-ebook/topic/all/language/all";
			break;
		case "product-demo":
			window.location = "/resources/#/type/product-demo/topic/all/language/all";
			break;
		case "product-guide":
			window.location = "/resources/#/type/product-guide/topic/all/language/all";
			break;
		case "webcast":
			window.location = "/resources/#/type/webcast/topic/all/language/all";
			break;
		case "whitepaper":
			window.location = "/resources/#/type/whitepaper/topic/all/language/all";
			break;
		case "vmdr":
			window.location = "/resources/#/type/all/topic/Vulnerability Management/language/all";
			break;
		}
	}

	$(document).ready(function () {
		handleHashchange();
		hideAllSections();
		hideAllItems();
		buildDropdowns();
		handleClickingOfCheckboxes();
		handleExpandCollapseFilterDropdowns();
		args = getArgs(getHash());
		expressArguments(args);
		updateTally();
		showOrHideAssets();
	});

	$(window).on("hashchange", handleHashchange);

	/*
	 * Hide all sections
	 */
	function hideAllSections(){
		var resourcesCategory = $(".q-resources-filter__category");
		resourcesCategory.addClass("q-resources-filter__category--closed");
	}

	/*
	 * Hide all items
	 */
	function hideAllItems(){
		var resourcesItem = $(".q-resources-filter__item");
		resourcesItem.addClass("asset");
	}

	/*
	 * build dropdown menus
	 */
	function buildDropdowns() {
		// create array of language codes, resource types and topics
		var languages = $(".q-resources-filter__category-wrapper .q-resources-filter__item").map(function (index, element) {
			return $(element).attr("lang");
		});
		var types = $(".q-resources-filter__category-wrapper .q-resources-filter__item").map(function (index, element) {
			return $(element).attr("data-typeName");
		});
		var topics = $(".q-resources-filter__category-wrapper .q-resources-filter__item").map(function (index, element) {
			var topic = $(element).attr("data-topics");

			// if there's a comma-delimited list of topics, convert it to an array
			if (topic.indexOf(",") !== -1) {
				topic = topic.split(",");
			}
			return topic;
		});

		// get unique values of language codes, resource types and topics
		languages = _.uniq(languages);
		types = _.uniq(types);
		topics = _.uniq(topics);

		// sort language codes, resource types alphabetically
		languages = _.sortBy(languages, function (item) {
			return item;
		});
		types = _.sortBy(types, function (item) {
			return item;
		});
		topics = _.sortBy(topics, function (item) {
			return item;
		});

		// for topics, rearrange the order of items

		var scqIndex = topics.indexOf("Security Assessment Questionnaire");
		if (scqIndex !== -1) {
			topics.splice(scqIndex, 1);
			topics.unshift("Security Assessment Questionnaire");
		}

		var scaIndex = topics.indexOf("Security Configuration Assessment");
		if (scaIndex !== -1) {
			topics.splice(scaIndex, 1);
			topics.unshift("Security Configuration Assessment");
		}

		var fimIndex = topics.indexOf("File Integrity Monitoring");
		if (fimIndex !== -1) {
			topics.splice(fimIndex, 1);
			topics.unshift("File Integrity Monitoring");
		}

		var pciIndex = topics.indexOf("PCI Compliance");
		if (pciIndex !== -1) {
			topics.splice(pciIndex, 1);
			topics.unshift("PCI Compliance");
		}

		var pcIndex = topics.indexOf("Policy Compliance");
		if (pcIndex !== -1) {
			topics.splice(pcIndex, 1);
			topics.unshift("Policy Compliance");
		}

		var wafIndex = topics.indexOf("Web Application Firewall");
		if (wafIndex !== -1) {
			topics.splice(wafIndex, 1);
			topics.unshift("Web Application Firewall");
		}

		var wasIndex = topics.indexOf("Web Application Scanning");
		if (wasIndex !== -1) {
			topics.splice(wasIndex, 1);
			topics.unshift("Web Application Scanning");
		}
		
		var csamindex = topics.indexOf("CyberSecurity Asset Management");
		if (csamindex !== -1) {
			topics.splice(csamindex, 1);
			topics.unshift("CyberSecurity Asset Management");
		}

		var csIndex = topics.indexOf("Container Security");
		if (csIndex !== -1) {
			topics.splice(csIndex, 1);
			topics.unshift("Container Security");
		}

		var iocIndex = topics.indexOf("Indication of Compromise");
		if (iocIndex !== -1) {
			topics.splice(iocIndex, 1);
			topics.unshift("Indication of Compromise");
		}

		var cmIndex = topics.indexOf("Continuous Monitoring");
		if (cmIndex !== -1) {
			topics.splice(cmIndex, 1);
			topics.unshift("Continuous Monitoring");
		}

		var tpIndex = topics.indexOf("Threat Protection");
		if (tpIndex !== -1) {
			topics.splice(tpIndex, 1);
			topics.unshift("Threat Protection");
		}

		var vmIndex = topics.indexOf("Vulnerability Management");
		if (vmIndex !== -1) {
			topics.splice(vmIndex, 1);
			topics.unshift("Vulnerability Management");
		}

		var aiIndex = topics.indexOf("Asset Inventory");
		if (aiIndex !== -1) {
			topics.splice(aiIndex, 1);
			topics.unshift("Asset Inventory");
		}

		var etIndex = topics.indexOf("Enterprise TruRisk™");
		if (etIndex !== -1) {
			topics.splice(etIndex, 1);
			topics.unshift("Enterprise TruRisk™");
		}




		// create array of language code, resource type HTML list items
		var langHtml = languages.map(function (item) {
			return "<li><label><input value=\"" + item + "\" type=\"checkbox\" class=\"" + item + "\"> " + item.toUpperCase() + "</label></li>";
		});
		var typeHtml = types.map(function (item) {
			var itemLabel = item;
			if (item === "Webcast") {
				itemLabel = "Webinar";
			}
			return "<li><label><input value=\"" + item.toLowerCase().replace(" ", "-") + "\" type=\"checkbox\" class=\"" + item + "\"> " + itemLabel + "</label></li>";
		});
		var topicHtml = topics.map(function (item) {
			return "<li><label><input value=\"" + item + "\" type=\"checkbox\" class=\"" + item + "\"> " + item + "</label></li>";
		});

		// convert language, resource type HTML arrays to string
		langHtml = langHtml.join("");
		typeHtml = typeHtml.join("");
		topicHtml = topicHtml.join("");

		// append language, resource type HTML to page
		$("ul.language").append(langHtml);
		$(".language input.en").prop("checked",true);
		$("ul.type").append(typeHtml);
		$("ul.topic").append(topicHtml);
	}

	/*
	 * update dropdown number indicator
	 */
	function updateTally() {
		var filtertypes = ["type", "topic", "language"];

		$.each(filtertypes, function (index, filterType) {
			var count = $("ul." + filterType + " li input:checked").length;
			if (count > 0) {
				if ($("ul." + filterType + " li input.all:checked").length ) {
					$("ul." + filterType).siblings("strong").find("span").html("(" + ($("ul." + filterType + " li input").length - 1) + ")");
				} else {
					$("ul." + filterType).siblings("strong").find("span").html("(" + count + ")");
				}
			} else {
				$("ul." + filterType).siblings("strong").find("span").html("");
			}
		});
	}

	/*
	 * show or hide assets
	 */
	function showOrHideAssets() {
		// hide all categories and resources
		$(".q-resources-filter__category-wrapper a").removeClass("active");

		// build array of user-selected types
		var typeFilter = [];

		$("ul.type input:checked").each(function (index, element) {
			if ($(element).val() !== "all") {
				typeFilter.push("[data-typeId='" + $(element).val() + "']");
			}
		});

		// if user checks "all" checkbox, then array will be empty, so replace with all options
		if (typeFilter.length === 0) {
			$("ul.type input").each(function (index, element) {
				typeFilter.push("[data-typeId='" + $(element).val() + "']");
			});
		}

		typeFilter = typeFilter.join();

		// build array of user-selected topics
		var topicFilter = [];

		$("ul.topic input:checked").each(function (index, element) {
			if ($(element).val() !== "all") {
				topicFilter.push("[data-topics*='" + $(element).val() + "']");
			}
		});

		// if user checks "all" checkbox, then array will be empty, so replace with all options
		if (topicFilter.length === 0) {
			$("ul.topic input").each(function (index, element) {
				topicFilter.push("[data-topics*='" + $(element).val() + "']");
			});
			topicFilter.push("[data-topics='']");
		}

		topicFilter = topicFilter.join();

		// build array of user-selected languages
		var langFilter = [];
		$("ul.language input:checked").each(function (index, element) {
			if ($(element).val() !== "all") {
				langFilter.push("[lang='" + $(element).val() + "']");
			}
		});

		// if user checks "all" checkbox, then array will be empty, so replace with all options
		if (langFilter.length === 0) {
			$("ul.language input").each(function (index, element) {
				langFilter.push("[lang='" + $(element).val() + "']");
			});
		}

		langFilter = langFilter.join();

		/* for debugging 
		console.log(typeFilter);
		console.log(topicFilter);
		console.log(langFilter);
		console.log('$(".q-resources-filter__category-wrapper li").filter("' + langFilter + '").filter("' + typeFilter + '").filter("' + topicFilter + '").addClass("active")'); */

		// show resources that match user's selection
		$(".q-resources-filter__category-wrapper a").filter(langFilter).filter(typeFilter).filter(topicFilter).addClass("active");

		// show categories that contain resources
		$(".q-resources-filter__category-wrapper > a").each( function(i, element) {
			if ($(element).find("li.active").length > 0) {
				$(element).addClass("active");
			}
		});

		updateTally();
		showOrHideCategories();
		noResultsFound();
	}

	/*
	 * get hash tag
	 */
	function getHash() {
		var hash;
		if (window.location.hash) {
			/* Puts hash in variable, and removes the # character */
			hash = window.location.hash.substring(1);
			/* remove initial slash if it exists */
			hash = hash.indexOf("/") == 0 ? hash.substring(1) : hash;
		}
		else {
			hash = "";
		}
		return hash;
	}

	/*
	 * build hash based on checked checkboxes
	 */
	function buildHash() {
		var typeArray = [], topicArray = [], languageArray = [], val;

		// get all checked "types" as an array
		$("ul.type input:checked").each(function (index, element) {
			val = $(element).val();
			typeArray.push(val);
		});

		// get all checked "topics" as an array
		$("ul.topic input:checked").each(function (index, element) {
			val = $(element).val();
			topicArray.push(val);
		});

		// get all checked "languages" as an array
		$("ul.language input:checked").each(function (index, element) {
			val = $(element).val();
			languageArray.push(val);
		});

		// build hash based on checked checkboxes
		window.location.hash = "/type/" + typeArray.join(",") + "/topic/" + topicArray.join(",") + "/language/" + languageArray.join(",");
	}

	/*
	 * effect changes based on set of arguments
	 */
	function expressArguments(args) {
		$.each(args, function(key, value) {
			// convert comma-delimited list to array
			var valArray = value.split(",");

			// reset / uncheck all "type" checkboxes
			$("div.filterbox." + key + " input").prop("checked", false);
			// if a type is specified, check its checkbox
			$.each(valArray, function (index, value) {
				$("div.filterbox." + key + " input").each(function (index, element) {
					if ($(element).attr("value").trim() === value.replaceAll("%20", " ").trim()) {
						$(element).prop("checked", true);
					}
				});
			});
		});
	}
	/*
	 * convert hash into object of argument pairs
	 */
	function getArgs(hash) {
		// URL and hash should be in format
		// qualys.com/resources/#/type/datasheet,webcast/topic/vm,pc/language/en,fr
		var parts = [],
			args = {};
		parts = hash.split("/");

		if (parts.length) {
			for (var i = 0; i < parts.length; i++) {
				if (parts[i] === "type") {
					args[parts[i]] = parts[i+1];
				} else if (parts[i] === "topic") {
					args[parts[i]] = parts[i+1];
				} else if (parts[i] === "language") {
					args[parts[i]] = parts[i+1];
				}
			}
		}
		return args;
	}

	function handleClickingOfCheckboxes() {
		$("form.resource-filters input[type='checkbox']").on("change", function(event) {
			filterType = $(event.currentTarget).closest("ul").prop("class");
			filterType = filterType.replace("active", "").trim();

			// clicking on 'all' unchecks everything but all,
			// and clicking on everything unchecks 'all'
			if ($(event.currentTarget).attr("class") === "all") {
				if (event.currentTarget.checked) {
					$(event.currentTarget).closest("ul").find("input").not(".all").prop("checked", false);
				} else {
					$(event.currentTarget).closest("ul").find("input.all").prop("checked", true);
				}
			} else {
				if ($(event.currentTarget).closest("ul").find("input:checked").length === 0) {
					$(event.currentTarget).closest("ul").find("input.all").prop("checked", true);
				} else {
					$(event.currentTarget).closest("ul").find("input.all").prop("checked", false);
				}
			}

			buildHash();
			showOrHideAssets();
		});
	}

	function showOrHideCategories() {
		// show all categories
		$(".q-resources-filter__category").removeClass("hidden");

		// hide empty categories
		$(".q-resources-filter__category").each(function (index, item) {
			var numActiveAssets = $(item).find(".q-resources-filter__item.active").length;

			if (numActiveAssets === 0) {
				$(item).addClass("hidden");
			}
		});

		// if only one category is showing, expand it
		var $visibleCategories = $(".q-resources-filter__category:not(.hidden)");

		if ($visibleCategories.length === 1) {
			$visibleCategories.removeClass("q-resources-filter__category--closed");
		} else if ($visibleCategories.length > 1) {
			$visibleCategories.addClass("q-resources-filter__category--closed");
		}

		if (doOnce === false) {
			scrollToResourcesSection();
		}
	}

	function scrollToResourcesSection() {
		setTimeout(function(){
			if (window.location.hash) {
				var hash = window.location.hash.toLowerCase();
			}

			switch(hash) {
			case "#/type/analyst-report/topic/all/language/all":
			case "#/type/datasheet/topic/all/language/all":
			case "#/type/dummies-ebook/topic/all/language/all":
			case "#/type/product-demo/topic/all/language/all":
			case "#/type/product-guide/topic/all/language/all":
			case "#/type/webcast/topic/all/language/all":
			case "#/type/whitepaper/topic/all/language/all":
				var allResources = document.getElementById("all-resources");
				scrollTo(document.body, allResources.offsetTop - 40);
				doOnce = true;
				break;
			}
		}, 0);
	}

	function noResultsFound() {

		$(".q-resources__no-results").addClass("hidden");

		var numCategories = $(".q-resources-filter__category").length;
		var numHiddenCategories = $(".q-resources-filter__category.hidden").length;

		if(numHiddenCategories === numCategories) {
			$(".q-resources__no-results").removeClass("hidden");
		}

	}

	/*
	 * Handle expanding and collapsing of filter dropdowns
	 */
	function handleExpandCollapseFilterDropdowns() {
		$(".filterbox strong").on("click", function (event) {
			if ($(event.currentTarget).hasClass("open")) {
				// flip arrow
				$(event.currentTarget).removeClass("open");
				// disable overlay
				$(".q-resources-filter__dropdowns div.overlay").removeClass("open");
				// hide pulldown list
				$(event.currentTarget).parent("div").find("ul").removeClass("active");
				// hide filters
				$(event.currentTarget).closest("div.mobile-filter-toggle").siblings("div.filterbox").removeClass("mobile-active");
			} else {
				// close open pulldowns
				$(event.currentTarget).closest("form").find("ul").removeClass("active");
				$(event.currentTarget).closest("form").find("strong").not("div.mobile-filter-toggle strong").removeClass("open");
				// flip arrow
				$(event.currentTarget).addClass("open");
				// open pulldown
				$(event.currentTarget).next("ul").addClass("active");
				// reveal or hide filter categories when toggle is clicked
				if ($(event.currentTarget).closest("div.mobile-filter-toggle").is(":first-child")) {
					$(event.currentTarget).closest("div.filterbox").siblings("div.filterbox").addClass("mobile-active");
				} else {
					$(".q-resources-filter__dropdowns div.overlay").addClass("open");
				}
			}
		});
		$(".q-resources-filter__dropdowns > div.overlay").on("click", function () {
			$("form.resource-filters strong.open").not("div.mobile-filter-toggle strong").trigger("click");
		});

		// click handler to close any open filter dropdown menus when you click anywhere outside the filter dropdown
		$(document).on("click", function (event) {
			var container = $(".filterbox");

			if (!container.is(event.target) && container.has(event.target).length === 0) {
				$(".filterbox strong").each(function (index, element) {
					if ($(element).hasClass("open")) {
						$(element).trigger("click");
					}
				});
			}
		});
	}

}(jQuery, _));


/*
 * automatically expand previously opened resource type container when user clicks a resource and then clicks back
 * uses the browser's History API
 * https://developer.mozilla.org/en-US/docs/Web/API/History
 */
(function ($) {
	"use strict";

	$(document).ready(function () {
		// if the history state object isn't empty / null
		if (history.state !== null) {
			// click to expand the resource type specified in the history state object
			$("[data-category='" + history.state.type + "']").click();
		}

		// when user clicks a resource link
		$(".q-resources-filter__wrapper .asset").on("click", function (event) {
			// don't follow the clicked link yet
			// event.preventDefault();

			// get the resource's type
			var resourceType = $(event.currentTarget).parent().prev().attr("data-category");

			// and save it in the browser history state object
			history.replaceState({type: resourceType}, "Resource", "");

			// now follow the clicked link
			// window.location.href = $(event.currentTarget).attr("href");
		});
	});
}(jQuery));

/*
 * reset the dropdown filters when you click the reset link
 */
(function ($) {
	"use strict";

	$(document).ready(function () {
		// when user clicks the reset link
		$(".q-resources-filter__reset a").on("click", function () {
			// trigger a click on the first checkbox in all filters
			$(".filterbox input[class='all']").trigger("click");

			// clear the search box
			$("input.search").attr("value", "");

			// collapse all categories
			$(".q-resources-filter__category").addClass("q-resources-filter__category--closed");
		});
	});
}(jQuery));

/*
 * show "upcoming" label for webcasts in the future
 */
(function ($) {
	"use strict";

	$(document).ready(function () {
		// get all webcasts times
		$("#webcast a").each(function (index, element) {
			var eventDate = $(element).find("time").attr("datetime");

			// if webcast is in the future ...
			if (moment().diff(moment(eventDate)) < 0) {
				// show the "upcoming" label
				$(element).find(".label__upcoming").removeClass("hidden");
			}
		});
	});
}(jQuery));

/*
 * Convert time to user's local time
 */
(function () {

	"use strict";

	var datetime, element, elements, index;

	// set the locale based on the user's browser
	moment.locale(window.navigator.languages || window.navigator.language);

	// find time tags and update them
	elements = document.querySelectorAll("time[datetime]");
	for (index = 0; index < elements.length; index += 1) {

		element = elements.item(index);
		datetime = moment.tz(element.getAttribute("datetime"), moment.tz.guess());
		element.innerText = datetime.format("LLLL z");

	}

}());